import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03d61462"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d61462')) {
      api.createRecord('03d61462', component.options)
    } else {
      api.reload('03d61462', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03d61462", function () {
      api.rerender('03d61462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Deliveries/index.vue"
export default component.exports